import Algorithm from "../common/Algorithm";


const Constant = {
    NODE_HEIGHT: 26,                       //节点高度像素数
    NODE_SCROLL_WINDOW_COUNT: 200,         //滚动窗口节点数量，有一部分冗余
    NODE_SCROLL_VISIBLE_COUNT: 20,         //滚动窗口可见节点数
};


/**
 * 选择状态
 *
 * @type {{ALL: number, SOME: number, UNKNOWN: number, NONE: number}}
 */

const TreeSelectType = {
    UNKNOWN: -1,
    NONE: 0,  //未选
    ALL: 1,   //全选
    SOME: 2   //半选
};


/**
 * 获取选择状态
 *
 * @param node
 * @returns {number}
 */
const getSelected = function (node) {
    if (isLeaf(node)) {
        return node.selected ? TreeSelectType.ALL : TreeSelectType.NONE;
    }
    let ret = TreeSelectType.UNKNOWN;
    if (0 === node.selectedCount) {
        ret = TreeSelectType.NONE;
    } else if (node.selectedCount === node.totalCount) {
        ret = TreeSelectType.ALL;
    } else if (node.selectedCount > 0) {
        ret = TreeSelectType.SOME;
    }
    return ret;
};


/**
 * 节点递归全选
 * @param nodes
 * @param selectedIds
 */
const selectAll = function (nodes, selectedIds) {
    Algorithm.depthWorker(nodes, function (node) {
        if (isSelectable(node)) {
            selectedIds.set("" + node.id, {
                name: node.name,
                email: node.email,
                position: node.position,
                tel: node.tel,
                mobile: node.mobile,
                fax: node.fax,
                employeeId: node.employeeId,
                id: node.id
            });
            node.selected = true;
        }
    });
};


/**
 * 节点递归不选
 *
 * @param nodes
 * @param selectedIds
 */
const unSelectAll = function (nodes, selectedIds) {
    Algorithm.depthWorker(nodes, function (node) {
        if (isSelectable(node)) {
            selectedIds.delete("" + node.id);
            node.selected = false;
        }
    });
};


/**
 * 计算已选数量
 * //TODO 部分计算优化性能
 * @param node
 * @returns {number}
 */
const computeSelectedCount = function (node) {
    if (!node) {
        return 0;
    }

    if (Array.isArray(node)) {
        let count = 0;
        node.forEach(function (item) {
            count += computeSelectedCount(item);
        });
        return count;
    }

    if (!isLeaf(node)) {
        let selectedCount = computeSelectedCount(node.children);
        if (node.selectedCount !== selectedCount) {
            node.selectedCount = selectedCount;
        }
        return node.selectedCount;
    }

    return node.selected ? 1 : 0;
};


/**
 * 初始化辅助字段数据
 */
const initTree = function (root, options) {
    if ('object' === typeof options) {
        //需要提前剪裁
        if (options.predPruned) {
            root = pruneTree(root, options.predPruned);
        }

        //隐藏叶子（非Folder）节点
        let predHiddened = options.predHiddened;
        if (options.hiddenLeaf) {
            predHiddened = 'function' === typeof options.predHiddened ?
                (n => (!Array.isArray(n) && isLeaf(n)) || options.predHiddened(n)) : (n => !Array.isArray(n) && isLeaf(n));
        }

        //需要提前隐藏
        if ('function' === typeof predHiddened) {
            Algorithm.depthWorker(root, n => {
                n.hidden = !!predHiddened(n);
            });
        }
    }

    initTreeData(root);
    computeSelectedCount(root);
    computeSerialNumber(root);
    return root;
};


/**
 * 裁剪树
 */
const pruneTree = function (nodes, fiter) {
    if (Array.isArray(nodes)) {
        let res = [];
        nodes.forEach(function (node) {
            let item = pruneTree(node, fiter);
            if (item) {
                res.push(node);
            }
        });
        return res;
    } else if ('object' === typeof nodes) {
        if (!fiter(nodes)) {
            return undefined;
        }
        nodes.children = pruneTree(nodes.children, fiter);
        return nodes;
    }
    return undefined;
}


/**
 * 创建节点
 *
 * @param id
 * @param label
 * @returns {{id: *, label: *}}
 */
const createNode = function (id, label) {
    return {
        id,
        label,
    };
};


/**
 * 将节点加入到父节点中
 *
 * @param parent
 * @param child
 */
const addChild = function (parent, child) {
    if (!parent || !child) {
        return;
    }

    if (typeof parent.children === "undefined") {
        parent.children = [];
    }
    parent.children.push(child);
};


/**
 * 计算节点区间序列值
 *
 * @param nodes
 * @param serialNumber
 * @returns {number|*}
 */
const computeSerialNumber = function (nodes, serialNumber) {
    if (!nodes) {
        return serialNumber;
    }

    let serial = (typeof serialNumber === "undefined") ? 0 : serialNumber;

    if (Array.isArray(nodes)) {
        nodes.forEach(function (node) {
            if (node.hidden) {
                return;
            }
            node.range.y = node.range.x = serial++;
            if (node.isExpanded) {
                serial = computeSerialNumber(node.children, serial);
                node.range.y = serial - 1;
            }
        });
    } else if (!nodes.hidden) {
        nodes.range.y = nodes.range.x = serial++;
        if (nodes.isExpanded) {
            serial = computeSerialNumber(nodes.children, serial);
            nodes.range.y = serial - 1;
        }
    }
    return serial;
};


/**
 * 获取节点及其子孙所有展开的节点数
 *
 * @param nodes
 * @returns {number}
 */
const getExpandedNodeCount = function (nodes) {
    if (!nodes) {
        return 0;
    }
    let count = 0;
    console.log("getExpandedNodeCount");
    if (Array.isArray(nodes)) {
        for (let node of nodes) {
            count += 1 + node.range.y - node.range.x;
        }
        return count;
    } else {
        return 1 + this.range.y - this.range.x;
    }
};


/**
 * 查找数组中匹配区间的节点下标（正向）
 *
 * @param nodes
 * @param range
 * @returns {number}
 */
const firstIndexOfRange = function (nodes, range) {
    if (range && nodes && nodes.length && nodes.length > 0) {
        if (Algorithm.isRangeOverlap(range, nodes[0].range)) {
            console.log("ok11", nodes[0].range, range);
            return 0;
        }

        let pos = Algorithm.binarySearch(nodes, function (node) {
            if (Algorithm.isRangeOverlap(range, node.range)) {
                return 0;
            }
            return range.x - node.range.y;
        });

        for (let i = pos; i >= 0; i--) {
            if (!Algorithm.isRangeOverlap(range, nodes[i].range)) {
                return i + 1;
            }
        }
    }
    return -1;
};


/**
 * 查找数组中匹配区间的节点下标（反向）
 *
 * @param nodes
 * @param range
 * @returns {number}
 */
const lastIndexOfRange = function (nodes, range) {
    if (range && nodes && nodes.length && nodes.length > 0) {
        if (Algorithm.isRangeOverlap(range, nodes[nodes.length - 1].range)) {
            return nodes.length - 1;
        }

        let pos = Algorithm.binarySearch(nodes, function (node) {
            if (Algorithm.isRangeOverlap(range, node.range)) {
                return 0;
            }
            return range.x - node.range.y;
        });

        if (pos < 0) {
            return -1;
        }

        for (let i = pos; i < nodes.length; i++) {
            if (!Algorithm.isRangeOverlap(range, nodes[i].range)) {
                return i - 1;
            }
        }
    }
    return -1;
};


function freezeNode(node) {
    node.id = Object.freeze(node.id);
    node.name = Object.freeze(node.name);
    if (typeof node.email !== "undefined") {
        node.email = Object.freeze(node.email);
    }
    if (typeof node.isFolder !== "undefined") {
        node.isFolder = Object.freeze(node.isFolder);
    }
    if (typeof node.isExpandable !== "undefined") {
        node.isExpandable = Object.freeze(node.isExpandable);
    }
    if (typeof node.hidden !== "undefined") {
        node.hidden = Object.freeze(node.hidden);
    }
    if (typeof node.pinyin !== "undefined") {
        node.pinyin = Object.freeze(node.pinyin);
    }
    if (typeof node.totalCount !== "undefined") {
        node.totalCount = Object.freeze(node.totalCount);
    }
}


/**
 * 初始化全部可选数量，及一些标记位
 *
 * @param node
 * @returns {number}
 */
function initTreeData(node, parent) {
    if (!node) {
        return 0;
    }

    if (Array.isArray(node)) {
        let count = 0;
        node.forEach(function (item) {
            count += initTreeData(item, parent);
        });
        return count;
    }

    node.parent = parent;
    node.range = {x: 0, y: 0};
    node.isExpanded = false;
    node.isFolder = isFolder(node);
    node.isExpandable = isExpandable(node);

    if (isLeaf(node)) {
        node.selected = false; //TODO
        return isSelectable(node) ? 1 : 0;
    } else {
        node.totalCount = initTreeData(node.children, node);
        return node.totalCount;
    }
}


/**
 * 是否为中间节点，可展开
 * @param node
 * @returns {*}
 */
function isFolder(node) {
    return node && node.children && Array.isArray(node.children);
}


/**
 * 节点是否可以被展开
 */
function isExpandable(node) {
    return isFolder(node) && !!node.children.find(v => !v.hidden);
}


/**
 * 是否是叶子节点
 *
 * @param node
 * @returns {*|boolean}
 */
function isLeaf(node) {
    return node && (typeof node.children === "undefined") && !Array.isArray(node);
}


/**
 * 节点是否可被最终选择
 *
 * @param node
 * @returns {*|boolean}
 */
function isSelectable(node) {
    return node && (typeof node.selected !== "undefined");
}


/**
 * 滚动窗口可见范围
 *
 * @param scrollTop
 * @returns {{x: number, y: number}}
 */
const getScrollVisibleRange = function (scrollTop) {
    let x = Math.max(0, Math.floor(scrollTop / Constant.NODE_HEIGHT));
    return {x: x, y: x + Constant.NODE_SCROLL_VISIBLE_COUNT};
};


/**
 * 获取滚动窗口填充和应显示节点信息（仅一次forEach遍历、针对超大数组优化）
 *
 * @param node
 * @param range
 * @returns {{visibleChildren: [], fillerAfterCount: number, fillerBeforeCount: number}}
 */
const getScrollFillerInfo = function (node, range) {
    let res = {fillerBeforeCount: 1, visibleChildren: [], fillerAfterCount: 1};
    if (((typeof node.isExpanded !== "undefined") && !node.isExpanded) || node.range.x === node.range.y) {
        return res;
    }

    let first;
    let last;
    let lastNode;
    let work = true;
    node.children.forEach(function (v) {
        lastNode = v;
        if (work && Algorithm.isRangeOverlap(range, v.range)) {
            if (typeof first === "undefined") {
                first = v;
            }
            last = v;
            res.visibleChildren.push(v);
        } else if (last) {
            work = false;
        }
    });

    if (typeof first === "undefined") {
        res.fillerBeforeCount = node.range.y - node.range.x;
        return res;
    }

    res.fillerBeforeCount = first.range.x - node.children[0].range.x;
    res.fillerAfterCount = lastNode.range.y - last.range.y;
    return res;
};


export default {
    Constant,
    TreeSelectType,
    createNode,
    addChild,
    getSelected,
    selectAll,
    unSelectAll,
    initTree,
    computeSelectedCount,
    computeSerialNumber,
    getExpandedNodeCount,
    firstIndexOfRange,
    lastIndexOfRange,
    getScrollVisibleRange,
    getScrollFillerInfo,
};



// WEBPACK FOOTER //
// ./src/components/core/tree/TreeUtil.js